export default __webpack_public_path__ + "static/stanislaws-66824101090a9c4f144fca36c38f9aad.png";